module.exports = ( User, Api ) ->
  return {
    scope:
      states:             '='
      project:            '='
      projectPermissions: '='
      onStateChange:      '='
    controller: ( $scope ) ->
      $scope.user = User
      $scope.userCanEditReportName = User.hasPermission('workflow.can_change_report_name', false)

      savedReportName = $scope.project.name
      editReportNameMode = false

      $scope.isEditingReportName = () ->
        editReportNameMode

      $scope.enableEditReportNameMode = () ->
        editReportNameMode = true

      $scope.saveReportName = () ->
        if savedReportName != $scope.project.name
          $scope.project.$update()
          savedReportName = $scope.project.name
        editReportNameMode = false

      $scope.encryptedMetadataGetter = () ->
        return Api.ProjectEncryptedMetadata.get(
          {id: $scope.project.id}
        ).$promise.then((project) -> project.encrypted_metadata)

    template: require('./report-title-bar.html')
  }
